import {NgModule} from '@angular/core';
import {CommonModule} from '@angular/common';
import {InputComponent} from './input.component';
import {FormsModule, ReactiveFormsModule} from '@angular/forms';
import {InputIconComponent} from './input-icon/input-icon.component';
import {InputPlaceholderComponent} from './input-placeholder/input-placeholder.component';
import {InputLabelComponent} from './input-label/input-label.component';
import {EmailValidatorDirective} from './validators/email-validator.directive';
import {InputErrorComponent} from './input-error/input-error.component';
import {TooltipModule} from '../tooltip/tooltip.module';


@NgModule({
  declarations: [
    InputComponent,
    InputIconComponent,
    InputPlaceholderComponent,
    InputLabelComponent,
    EmailValidatorDirective,
    InputErrorComponent
  ],
  imports: [
    CommonModule,
    ReactiveFormsModule,
    FormsModule,
    TooltipModule,
  ],
  exports: [
    InputComponent,
    InputIconComponent,
    InputPlaceholderComponent,
    InputLabelComponent,
    EmailValidatorDirective,
    InputErrorComponent
  ],
  providers: [EmailValidatorDirective]
})
export class InputModule {
}
